import colorPalette from '../color-palette';

const { primary, action, text } = colorPalette;

export default {
  MuiButton: {
    root: {
      height: '50px',
      width: '100%',
      borderRadius: '5px',
      padding: '15px 20px',
    },
    label: {
      color: text.contrastText,
      textAlign: 'center' as const,
      alignItems: 'center',
    },
    contained: {
      height: '50px',
      width: '100%',
      borderRadius: '5px',
      padding: '15px 20px',
      backgroundColor: `${primary.main}`,
      '&:hover, &:active': {
        backgroundColor: primary.main,
        '@media (hover: none)': {
          backgroundColor: `${primary.main} !important`,
        },
      },
      '&:hover.Mui-disabled': {
        backgroundColor: `${action.disabled} !important`,
        '@media (hover: none)': {
          backgroundColor: action.disabled,
        },
      },
      '&:disabled': {
        backgroundColor: action.disabled,
        '& > $label': {
          color: text.contrastText,
        },
      },
    },
    text: {
      height: 'auto',
      width: 'auto',
      padding: 0,
      margin: 0,
      minWidth: 'auto',
      borderRadius: 0,
    },
  },
};
